@if (isLoading()) {
  <div class="bg-amber-50 border border-outline-brown flex flex-col overflow-hidden rounded-lg shadow-module h-full">
    <div class="flex items-center justify-between p-3 border-b border-outline-brown">
      <p-skeleton width="15rem" height="1.75rem"></p-skeleton>
    </div>
    <div class="p-3 h-full flex flex-col gap-4 flex-1 overflow-y-auto">
      <div class="bg-surface-50 p-4 rounded-md">
        <div class="flex items-center gap-2 mb-3">
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
          <p-skeleton width="8rem" height="1.25rem"></p-skeleton>
        </div>
        <div class="flex flex-col gap-3">
          <div>
            <div class="flex items-center mb-2">
              <p-skeleton width="10rem" height="1rem"></p-skeleton>
              <div class="ml-auto">
                <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div>
            <div class="flex items-center mb-2">
              <p-skeleton width="10rem" height="1rem"></p-skeleton>
              <div class="ml-auto">
                <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
              </div>
            </div>
            <p-skeleton width="20rem" height="1.5rem" borderRadius="0.5rem"></p-skeleton>
          </div>
        </div>
      </div>
      <div class="bg-surface-50 p-4 rounded-md">
        <div class="flex items-center gap-2 mb-3">
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
          <p-skeleton width="12rem" height="1.25rem"></p-skeleton>
        </div>
        <div class="mb-3">
          <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
        </div>
        <div class="mb-3">
          <div class="flex items-center mb-2">
            <p-skeleton width="7rem" height="1rem"></p-skeleton>
            <div class="ml-auto">
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
            </div>
          </div>
          <div class="flex items-center">
            <p-skeleton width="5rem" height="1rem"></p-skeleton>
            <div class="ml-auto">
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="6rem" borderRadius="0.375rem"></p-skeleton>
        </div>
        <div class="flex justify-center">
          <p-skeleton width="10rem" height="2.5rem" borderRadius="0.375rem" styleClass="ml-auto"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div
    [class]="
      isMobile()
        ? 'bg-surface-0 flex flex-col h-full overflow-hidden'
        : 'border border-1 border-amber-500 flex flex-col rounded-2xl shadow-module h-full overflow-hidden'
    "
  >
    <div class="flex items-center p-4 border-b border-outline-brown z-10">
      <h2 class="text-primary-500 m-0 text-body-700 flex items-center gap-1.5">
        <span
          class="flex items-center justify-center w-5 h-5 rounded-full bg-primary-500 text-white text-body-xs-700 shrink-0"
          >{{ dealAddendum().seq }}</span
        >
        <span class="text-primary-500">{{ dealAddendum().builderReference.reference }}</span>
      </h2>
      <button
        type="button"
        class="md:!hidden ml-auto p-1 -mr-1 flex items-center justify-center text-surface-400 hover:text-surface-700 bg-transparent border-none cursor-pointer"
        (click)="onClose.emit()"
      >
        <i class="pi pi-times text-base"></i>
      </button>
    </div>
    <form
      class="px-4 pt-0.5 pb-4 flex flex-col flex-1 overflow-y-auto"
      [formGroup]="addendumForm"
      (ngSubmit)="updateAddendum()"
    >
      <div class="flex items-center gap-2">
        <h3 class="text-body-md-600 text-primary-500 m-0">Approvals</h3>
        <dsm-changes-saved [savedAt]="approvalsSaved()" />
      </div>
      @if (dealAddendum().isCancelled || dealCancelled()) {
        <div class="flex flex-col gap-2 mt-2">
          <div>
            <div class="flex items-center">
              <div class="flex flex-col">
                <span class="text-body-sm-500 text-surface-700"> Buyer Approved </span>
                @if (dealAddendum().buyerApproved && dealAddendum().buyerApprovedDate) {
                  <span class="text-body-xs-500 gap-1 text-green-600 inline-flex mb-2">
                    Approved: {{ dealAddendum().buyerApprovedDate | date: 'MMM d, y, h:mm a' }}
                  </span>
                }
              </div>
              <p-toggleswitch
                [ngModel]="buyerApproved()"
                [ngModelOptions]="{ standalone: true }"
                class="whitespace-nowrap ml-auto"
                [disabled]="true"
              />
            </div>
          </div>
          <div>
            <div class="flex items-center">
              <div class="flex flex-col">
                <span class="text-body-sm-500 text-surface-700"> Builder Approved </span>
                @if (dealAddendum().builderApproved && dealAddendum().builderApprovedDate) {
                  <span class="text-body-xs-500 gap-1 text-green-600 inline-flex">
                    Approved: {{ dealAddendum().builderApprovedDate | date: 'MMM d, y, h:mm a' }}
                  </span>
                }
              </div>

              <p-toggleswitch
                [ngModel]="builderApproved()"
                [ngModelOptions]="{ standalone: true }"
                class="whitespace-nowrap ml-auto"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
      } @else {
        <div class="flex flex-col gap-2 mt-2">
          @if (!hideBuyerApproved()) {
            <div>
              <div class="flex items-center">
                <div class="flex flex-col">
                  <span class="text-body-sm-500 text-surface-700 flex items-center">
                    Buyer Approved
                    @if (dealAddendum().products.length === 0) {
                      <i
                        class="pi pi-exclamation-circle text-red-600 ml-2"
                        pTooltip="Cannot approve an empty addendum."
                        tooltipPosition="top"
                      ></i>
                    }
                  </span>
                  @if (dealAddendum().buyerApproved && dealAddendum().buyerApprovedDate) {
                    <span class="text-body-xs-500 gap-1 text-green-600 inline-flex mb-2">
                      Approved: {{ dealAddendum().buyerApprovedDate | date: 'MMM d, y, h:mm a' }}
                    </span>
                  }
                </div>
                @if (dealAddendum().products.length === 0 || !canApproveAddendumViaRbac() || isLockedAndCannotEdit()) {
                  <p-toggleswitch
                    [ngModel]="buyerApproved()"
                    [ngModelOptions]="{ standalone: true }"
                    class="whitespace-nowrap ml-auto"
                    [disabled]="true"
                  />
                } @else {
                  <p-toggleswitch
                    class="whitespace-nowrap ml-auto"
                    [ngModel]="buyerApproved()"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="updateBuyerApproval($event.checked)"
                  />
                }
              </div>
            </div>
          }
          <div>
            <div class="flex items-center">
              <div class="flex flex-col">
                <span class="text-body-sm-500 text-surface-700">
                  Builder Approved
                  @if (
                    dealAddendum().addendumType.name === AddendumType.INI && !isUnderContract() && !builderApproved()
                  ) {
                    <i
                      class="pi pi-exclamation-circle text-red-600 ml-2"
                      pTooltip="Contract is pending. You cannot approve this addendum as builder yet."
                      tooltipPosition="top"
                    ></i>
                  } @else if (dealAddendum().builderApproved && !dealAddendum().builderApprovedDate) {
                    <i
                      class="pi pi-exclamation-circle text-red-600 ml-2"
                      pTooltip="Builder approval date is required to proceed with approvals."
                      tooltipPosition="top"
                    ></i>
                  }
                </span>
                @if (dealAddendum().builderApproved && dealAddendum().builderApprovedDate) {
                  <span class="text-body-xs-500 gap-1 text-green-600 inline-flex">
                    Approved: {{ dealAddendum().builderApprovedDate | date: 'MMM d, y, h:mm a' }}
                  </span>
                }
              </div>
              @if (
                dealAddendum().products.length === 0 ||
                !canApproveAddendumViaRbac() ||
                (!canEditWhenLocked() &&
                  (isLockedAndCannotEdit() ||
                    (dealAddendum().addendumType.name === AddendumType.INI &&
                      !isUnderContract() &&
                      !builderApproved())))
              ) {
                <p-toggleswitch
                  [ngModel]="builderApproved()"
                  [ngModelOptions]="{ standalone: true }"
                  class="whitespace-nowrap ml-auto"
                  [disabled]="true"
                />
              } @else {
                <p-toggleswitch
                  class="whitespace-nowrap ml-auto"
                  [ngModel]="builderApproved()"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="updateBuilderApproval($event.checked)"
                />
              }
            </div>
            @if (dealAddendum().builderApproved && !dealAddendum().builderApprovedDate) {
              <!--
            <div class="flex items-center gap-2 text-red-600 text-body-xs mt-2">
              <i class="pi pi-exclamation-circle"></i>
              Builder approval date is required to proceed with approvals.
            </div>
            -->
            }
          </div>
        </div>
      }

      <div class="pt-8">
        <div class="flex items-center justify-between gap-2 mb-2">
          <h3 class="text-body-600 text-primary-500 m-0">Addendum Details</h3>
          <dsm-changes-saved [savedAt]="detailsSaved()" />
        </div>
        <div class="mb-4">
          <p-floatlabel variant="on">
            <generic-dropdown
              class="w-full"
              [allowSearch]="true"
              [items]="builderReferences()"
              [disabled]="isLocked()"
              formControlName="builderReferenceId"
            />
            <label>Builder Reference</label>
          </p-floatlabel>
        </div>
        <div class="mb-4 flex flex-col gap-1">
          <div class="flex items-center">
            <span class="text-body-sm-500 text-surface-700 mr-auto">In Contract</span>
            <p-toggleswitch [disabled]="isLocked()" formControlName="inContract" (onChange)="updateAddendum()" />
          </div>
          <div class="flex items-center">
            <span class="text-body-sm-500 text-surface-700 mr-auto">Cash</span>
            <p-toggleswitch
              [disabled]="isCashDisabled()"
              formControlName="cash"
              (onChange)="updateCash($event.checked)"
            />
          </div>
          @if (addendumForm.get('cash')?.value && dealAddendum().addendumType.name === AddendumType.INI) {
            <div class="flex items-center pl-4 py-1">
              <span class="text-body-sm-500 text-surface-700 mr-auto">↳ Received</span>
              <button
                type="button"
                (click)="openDepositsModal()"
                class="text-body-sm-600 text-emerald-700 font-semibold hover:underline border-none bg-transparent cursor-pointer p-0 select-none mr-1"
              >
                {{ receivedAmount() | currencyFormat }}
              </button>
            </div>
          }
          <div class="flex items-center">
            <span class="text-body-sm-500 text-surface-700 mr-auto">Include in APS</span>
            <p-toggleswitch
              [disabled]="isIncludeInApsDisabled()"
              formControlName="includeInAps"
              (onChange)="updateIncludeInAps($event.checked)"
            />
          </div>
        </div>
        <div>
          <label>Addendum Notes</label>
          <textarea
            pTextarea
            rows="4"
            class="w-full rounded-md"
            placeholder="Add Notes"
            [disabled]="isLocked()"
            formControlName="notes"
            (blur)="updateAddendum()"
          ></textarea>
        </div>
        <!--
        <div class="flex justify-center">
          <p-button
            label="Save Details"
            type="submit"
            [disabled]="isLocked()"
            class="w-full"
            styleClass="w-full justify-content-center"
          />
        </div>
        -->
        @if (!isLocked()) {
          <form [formGroup]="bulkDiscountForm" class="flex flex-col mt-3">
            <div class="flex flex-col">
              <p-floatlabel variant="on" class="w-full">
                <p-inputNumber
                  formControlName="percentage"
                  [min]="0"
                  [max]="100"
                  [maxFractionDigits]="2"
                  [allowEmpty]="true"
                  suffix=" %"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  (onBlur)="applyBulkDiscount()"
                />
                <label>Discount</label>
              </p-floatlabel>
            </div>
            <p-button
              label="Remove all Discounts"
              class="ms-auto h-4"
              link
              styleClass="underline p-0 text-body-xs text-red-500 hover:!text-red-700"
              (onClick)="clearAllDiscounts()"
            />
          </form>
        }
      </div>

      <!-- incentives section -->
      <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-3 mt-3">
        <div class="mb-3 flex items-center justify-between">
          <div class="flex items-center gap-2">
            <h3 class="text-base font-bold text-slate-800 m-0">Incentive</h3>
            <dsm-changes-saved [savedAt]="incentivesSaved()" />
          </div>

          <span class="text-sm font-semibold text-slate-500">Addendum-level</span>
        </div>

        <div class="mb-4 grid grid-cols-2 gap-3">
          <div class="rounded-lg border border-slate-200 bg-white p-3 py-2">
            <p class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-0">Applied Here</p>
            <p class="text-base font-bold text-slate-800 m-0 break-words">
              {{ dealAddendum().incentivesTotal | currencyFormat }}
            </p>
          </div>

          <div class="rounded-lg border border-emerald-200 bg-white p-3 py-2">
            <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700 mb-0">Available</p>
            <p class="text-base font-bold text-emerald-700 m-0 break-words">
              {{ incentiveRemaining() | currencyFormat }}
            </p>
          </div>
        </div>

        <p-button
          label="Apply Incentive"
          severity="primary"
          styleClass="w-full mb-2"
          [disabled]="isLocked()"
          (click)="openApplyIncentiveModal()"
        />

        <p class="text-center text-xs text-slate-500 mb-0">Distributes a lump amount across all options</p>
      </div>

      <div class="pt-8">
        <div class="flex items-center gap-2 mb-2">
          <h3 class="text-body-md-600 text-surface-700 m-0">Cost Breakdown</h3>
          <dsm-changes-saved [savedAt]="detailsSaved()" />
        </div>
        <div class="flex flex-col">
          <div class="flex flex-col gap-2">
            <div class="flex items-center justify-between">
              <span class="text-body-sm-500 text-surface-700">Options</span>
              <span class="text-body-sm-600 text-emerald-700">{{ dealAddendum().optionsTotal | currencyFormat }}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-body-sm-500 text-surface-700">Taxes</span>
              <span class="text-body-sm-600 text-emerald-700">{{ dealAddendum().taxesTotal | currencyFormat }}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-body-sm-500">Discounts</span>
              <span class="text-body-sm-600 text-emerald-700"
                >- {{ dealAddendum().discountsTotal | currencyFormat }}</span
              >
            </div>
            <div class="flex items-center justify-between">
              <span class="text-body-sm-500">Incentives</span>
              <span class="text-body-sm-600 text-emerald-700"
                >- {{ dealAddendum().incentivesTotal | currencyFormat }}</span
              >
            </div>
          </div>
          <!-- <hr class="border-slate-200 border border-1 my-1" /> -->
          <p-divider class="my-3" />
          <div class="flex items-center justify-between">
            <span class="text-body-500 text-surface-700">Total</span>
            <span class="text-body-700 text-surface-700">{{ dealAddendum().total | currencyFormat }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>

  <p-dialog
    [visible]="isDepositsModalVisible()"
    (visibleChange)="isDepositsModalVisible.set($event)"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '752px' }"
    header="Deposits and Payments"
    (onHide)="closeDepositsModal()"
    [draggable]="false"
    [appendTo]="'body'"
  >
    <div class="flex flex-col p-4 border border-slate-200 rounded-lg">
      <!-- Addendum Header Info - styled like addendum preview row -->
      @if (dealAddendum()) {
        <div class="rounded-md flex items-start gap-2.5">
          <span
            class="w-5 h-5 rounded-full bg-surface-700 text-white flex items-center justify-center text-body-2xs-700 shrink-0 mt-0.5"
          >
            {{ dealAddendum().seq }}
          </span>
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <h5 class="text-body-600 text-surface-700 m-0">
                {{ dealAddendum().builderReference.reference || '[Addendum Name]' }}
              </h5>
              <p-tag [value]="'Type: ' + dealAddendum().addendumType.name" size="small" severity="secondary" />
            </div>
            <div class="flex gap-2 flex-wrap items-center">
              <span class="inline-flex items-center gap-1 text-body-xs text-surface-500">
                <i class="pi pi-calendar text-body-sm"></i>
                {{ dealAddendum().documentDate | date: 'h:mm a, dd MMM yyyy' }}
              </span>
              @if (dealAddendum().buyerApproved) {
                <span class="inline-flex items-center gap-1 text-green-700">
                  <i class="pi pi-check-circle text-body-xs"></i>
                  <span class="text-body-xs-600">Buyer Approved</span>
                </span>
              }
              @if (dealAddendum().builderApproved) {
                <span class="inline-flex items-center gap-1 text-green-700">
                  <i class="pi pi-check-circle text-body-xs"></i>
                  <span class="text-body-xs-600">Builder Approved</span>
                </span>
              }
            </div>
          </div>
          <span class="text-body-sm text-primary-500 whitespace-nowrap shrink-0">
            Total: <span class="text-body-700 text-emerald-700">{{ receivedAmount() | currencyFormat }}</span>
          </span>
        </div>
      }
      <p-divider />
      <!-- Payment History Header - styled like Options header -->
      <div class="flex items-center gap-3 mb-2">
        <h3 class="m-0 text-body-600 text-surface-700">Payment History</h3>
        @if (!showAddForm() && hasValidOptions()) {
          <p-button class="ml-auto" icon="pi pi-plus" label="Add Deposit" (onClick)="onAddClick()" />
        }
      </div>
      @if (!hasValidOptions()) {
        <p-message severity="warn" styleClass="mb-2">
          Add an option to this addendum before recording deposits.
        </p-message>
      }
      <div class="flex flex-col gap-2">
        <!-- Add Deposit Form Container -->
        @if (showAddForm()) {
          <div class="overflow-hidden border border-outline-brown rounded-md">
            <dsm-aps-addendum-deposit-form
              [addendumId]="dealAddendum().id"
              [lotId]="dealAddendum().lotId"
              (formSaved)="onDepositSaved()"
              (formCancel)="onCancelAdd()"
            />
          </div>
        }

        @if (depositsView()?.deposits()?.length === 0 && !showAddForm() && hasValidOptions()) {
          <div
            class="flex flex-wrap items-center justify-center text-center border border-slate-200 rounded-md p-4 gap-2"
          >
            <p class="text-body-sm mb-0 text-surface-700">
              There are no deposits or payments. Start by adding a deposit.
            </p>
          </div>
        }
        @if (isDepositsModalVisible()) {
          <div class="flex flex-col max-h-[60vh] min-h-0">
            <dsm-aps-deposits
              [dealId]="depositsDealId()"
              [lotId]="dealAddendum().lotId"
              [addendumId]="dealAddendum().id"
              (changed)="onDepositsChanged()"
            />
          </div>
        }
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-end pt-2 border-t border-surface-200">
        <p-button label="Back to Addendums" severity="secondary" [outlined]="false" (onClick)="closeDepositsModal()" />
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    [visible]="isApplyIncentiveModalVisible()"
    (visibleChange)="isApplyIncentiveModalVisible.set($event)"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '640px' }"
    (onHide)="closeApplyIncentiveModal()"
    [draggable]="false"
    [appendTo]="'body'"
  >
    <ng-template pTemplate="header">
      <div class="flex items-center gap-3 min-w-0">
        <span
          class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-emerald-50 text-emerald-700 shrink-0"
          aria-hidden="true"
        >
          <i class="pi pi-dollar text-base font-bold"></i>
        </span>
        <div class="flex flex-col gap-0.5 min-w-0">
          <span class="font-semibold text-xl text-surface-800">Apply Incentive</span>
          <span class="text-body-sm text-surface-500 truncate">
            {{ dealAddendum().builderReference.reference }} · Auto-distribute across this addendum's options
          </span>
        </div>
      </div>
    </ng-template>

    <dsm-addendum-incentive-form
      #incentiveForm
      [addendumId]="dealAddendum().id"
      [currentAddendumIncentives]="dealAddendum().incentivesTotal"
      (formSaved)="onIncentiveSaved()"
      (formCancel)="closeApplyIncentiveModal()"
    />

    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2 w-full">
        <p-button label="Cancel" severity="secondary" (onClick)="closeApplyIncentiveModal()" />
        <p-button
          [label]="incentiveForm?.submitButtonLabel() ?? 'Apply'"
          [disabled]="incentiveForm?.isSubmitDisabled() ?? true"
          (onClick)="incentiveForm?.submit()"
        />
      </div>
    </ng-template>
  </p-dialog>
}
